import { useCallback, useState } from "react";
import { DADOS_FICTICIOS } from "./dadosFicticios";

export const modoTesteAtivo = process.env.REACT_APP_MODO_TESTE === "true";

const criarPdf = (nome: string) =>
  new File(
    [
      "%PDF-1.4\n" +
        "1 0 obj<</Type/Catalog/Pages 2 0 R>>endobj\n" +
        "2 0 obj<</Type/Pages/Kids[3 0 R]/Count 1>>endobj\n" +
        "3 0 obj<</Type/Page/Parent 2 0 R/MediaBox[0 0 595 842]>>endobj\n" +
        "trailer<</Size 4/Root 1 0 R>>\n%%EOF\n",
    ],
    nome,
    { type: "application/pdf" }
  );

const criarPng = (nome: string) => {
  const base64 =
    "iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg==";
  const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
  return new File([bytes], nome, { type: "image/png" });
};

const anexarArquivo = (input: HTMLInputElement) => {
  const aceita = (input.getAttribute("accept") ?? "").toLowerCase();
  const soImagem = aceita.includes("image") && !aceita.includes("pdf");

  const arquivo = soImagem ? criarPng("documento-teste.png") : criarPdf("fatura-teste.pdf");

  const transferencia = new DataTransfer();
  transferencia.items.add(arquivo);
  input.files = transferencia.files;

  input.dispatchEvent(new Event("input", { bubbles: true }));
  input.dispatchEvent(new Event("change", { bubbles: true }));
};

const preencherCampo = (campo: Element, valor: string) => {
  const prototipo =
    campo instanceof HTMLTextAreaElement
      ? HTMLTextAreaElement.prototype
      : campo instanceof HTMLSelectElement
      ? HTMLSelectElement.prototype
      : HTMLInputElement.prototype;

  const setter = Object.getOwnPropertyDescriptor(prototipo, "value")?.set;
  setter?.call(campo, valor);

  campo.dispatchEvent(new Event("input", { bubbles: true }));
  campo.dispatchEvent(new Event("change", { bubbles: true }));
};

const acharCampo = (pistas: string[]): Element | null => {
  const campos = Array.from(document.querySelectorAll("input, select, textarea")).filter(
    (campo) => !(campo instanceof HTMLInputElement && campo.type === "file")
  );

  return (
    campos.find((campo) => {
      const texto = [
        campo.getAttribute("name"),
        campo.getAttribute("id"),
        campo.getAttribute("placeholder"),
        campo.getAttribute("aria-label"),
        campo.closest("label")?.textContent,
        campo.parentElement?.textContent?.slice(0, 60),
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      return pistas.some((pista) => texto.includes(pista.toLowerCase()));
    }) ?? null
  );
};

const { contato, titularPf, titularPj, instalacao } = DADOS_FICTICIOS;

const MAPA: Array<[string[], string]> = [
  [["número da instalação", "numeroinstalacao"], ""],
  [["média de consumo", "ultimoconsumo", "consumo"], instalacao.ultimoConsumo],
  [["cep"], instalacao.cep],
  [["endereço", "endereco", "logradouro"], instalacao.endereco],
  [["bairro"], instalacao.bairro],
  [["cidade"], instalacao.cidade],
  [["número", "numero"], instalacao.numero],
  [["razão social", "razaosocial"], titularPj.razaoSocial],
  [["cnpj"], titularPj.cnpj],
  [["cpf"], titularPf.cpf],
  [["rg", "identidade"], titularPf.rg],
  [["nacionalidade"], titularPf.nacionalidade],
  [["telefone", "celular"], contato.telefone],
  [["nome"], contato.nome],
];

export const ModoTesteButton = () => {
  const [ultimoPreenchimento, setUltimoPreenchimento] = useState<number | null>(null);

  const preencher = useCallback(() => {
    let preenchidos = 0;
    const jaUsados = new Set<Element>();

    document.querySelectorAll<HTMLInputElement>('input[type="file"]').forEach((input) => {
      try {
        anexarArquivo(input);
        preenchidos++;
      } catch (erro) {
        console.warn("Modo teste: não consegui anexar arquivo neste campo.", erro);
      }
    });

    const campoInstalacao = acharCampo(["número da instalação", "numeroinstalacao"]);
    if (campoInstalacao) {
      preencherCampo(campoInstalacao, instalacao.numeroInstalacao());
      jaUsados.add(campoInstalacao);
      preenchidos++;
    }

    MAPA.forEach(([pistas, valor]) => {
      if (!valor) return;

      const campo = acharCampo(pistas);
      if (!campo || jaUsados.has(campo)) return;

      try {
        preencherCampo(campo, valor);
        jaUsados.add(campo);
        preenchidos++;
      } catch (erro) {
        console.warn(`Modo teste: falhei ao preencher "${pistas[0]}".`, erro);
      }
    });

    setUltimoPreenchimento(preenchidos);
  }, []);

  if (!modoTesteAtivo) return null;

  return (
    <button
      type="button"
      onClick={preencher}
      title="Preenche os campos visíveis com dados fictícios (somente desenvolvimento)"
      style={{
        position: "fixed",
        top: 12,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 2147483647,
        padding: "10px 14px",
        borderRadius: 999,
        border: "1px dashed #b45309",
        background: "#fef3c7",
        color: "#7c2d12",
        fontSize: 12,
        fontWeight: 700,
        cursor: "pointer",
        boxShadow: "0 2px 8px rgba(0,0,0,.15)",
      }}
    >
      MODO TESTE — preencher
      {ultimoPreenchimento !== null && ` (${ultimoPreenchimento})`}
    </button>
  );
};
